import { Observable } from 'rxjs';

export const LayoutBase2PageViewContractId = 'LayoutBase2PageViewContract';

export interface LayoutBase2PageViewContract {
  isLoading$: Observable<boolean>;
  name$: Observable<string>;
  email$: Observable<string>;
  picture$: Observable<string>;
  version$: Observable<string>;
  display$: Observable<string>;

  showCreatePrescription$: Observable<boolean>;
  showListPrescription$: Observable<boolean>;
  showListPatient$: Observable<boolean>;
  showListMedic$: Observable<boolean>;
  showListInstitution$: Observable<boolean>;
  showListUsers$: Observable<boolean>;
  showListConsumption$: Observable<boolean>;
  showListCompound$: Observable<boolean>;
  showListLine$: Observable<boolean>;
  showListFinancier$: Observable<boolean>;
  showListArticle$: Observable<boolean>;
  showListProduct$: Observable<boolean>;
  showListPurchaseOrder$: Observable<boolean>;
  showListRemito$: Observable<boolean>;
  showListSemaphore$: Observable<boolean>;
  showListPrescriptionReport$: Observable<boolean>;
  showListPrescriptionReportSummary$: Observable<boolean>;
  showListRemitosReport$: Observable<boolean>;

  logout(): Promise<void>;
  isMedicsRouteActive(): boolean;
  isInstitutionsRouteActive(): boolean;
}
